import { CURRENCY, ROUTES } from "../config";
import { SettingsEntityConfigByKey } from "./settings-config";

export const APL_ENTITY_CONFIG: SettingsEntityConfigByKey<"apl"> = {
  key: "apl",
  label: "APL",
  item: "APL",
  path: "apl",
  endpoints: {
    list: "/api/prices/active?show_all=true",
    getOne: (id) => `/api/prices/active/${id}`,
    create: "/api/prices/active",
    update: (id) => `/api/prices/active/${id}`,
    delete: (id) => `/api/prices/active/${id}`,
    restore: (id) => `/api/prices/active/${id}/restore`,
  },
  columns: [],
  fields: [
    {
      field: "route",
      label: "Route",
      control: "autocomplete",
      options: ROUTES,
      required: true,
      section: "general",
      filter: false,
      view: false,
      update: true,
    },
    {
      field: "service__route",
      label: "Route",
      control: "autocomplete",
      options: ROUTES,
      disabled: true,
      section: "general",
      filter: true,
      view: false,
      update: false,
      create: false,
    },
    {
      field: "service_id",
      label: "Service Master",
      control: "dynamic",
      api: "/api/services?type=ACTIVE",
      required: true,
      mapper: "master",
      section: "general",
      filter: false,
      update: true,
      option: "description_it",
      dependency: "route",
      dependencyParam: "route__in",
      initialValueMapper: (row) =>
        row.service_id
          ? {
              id: row.service_id,
              label: row.description_it || row.description,
            }
          : null,
    },
    {
      field: "ports",
      label: "Port",
      control: "dynamic",
      api: "/api/ports",
      path: "parent.id",
      multi: true,
      filter: false,
      required: true,
      section: "general",
    },
    {
      field: "carrier",
      label: "Carrier",
      control: "dynamic",
      api: "/api/suppliers/names",
      path: "carrier.id",
      filter: false,
      required: false,
      section: "general",
    },
    {
      field: "commodities",
      label: "Commodities",
      control: "groupped",
      filter: false,
      multi: true,
      section: "general",
      mapper: "commodityWithGroup",
      required: true,
    },
    {
      field: "price_currency",
      label: "Currency",
      control: "autocomplete",
      options: CURRENCY,
      required: true,
      section: "general",
    },
    {
      field: "warehouses_from",
      label: "Warehouses",
      control: "dynamic",
      api: "/api/warehouses",
      filter: false,
      section: "from",
      selectOption: true,
      multi: true,
    },
    {
      field: "terminals_from",
      label: "Terminals",
      control: "dynamic",
      api: "/api/terminals",
      filter: false,
      section: "from",
      selectOption: true,
      multi: true,
    },
    {
      field: "cities_from",
      label: "Cities",
      control: "dynamic",
      api: "/api/cities",
      filter: false,
      section: "from",
      selectOption: true,
      multi: true,
    },
    {
      field: "ports_from",
      label: "Ports",
      control: "dynamic",
      api: "/api/ports",
      filter: false,
      section: "from",
      selectOption: true,
      multi: true,
    },
    {
      field: "warehouses_to",
      label: "Warehouses",
      control: "dynamic",
      api: "/api/warehouses",
      filter: false,
      section: "to",
      selectOption: true,
      multi: true,
    },
    {
      field: "terminals_to",
      label: "Terminals",
      control: "dynamic",
      api: "/api/terminals",
      filter: false,
      section: "to",
      selectOption: true,
      multi: true,
    },
    {
      field: "cities_to",
      label: "Cities",
      control: "dynamic",
      api: "/api/cities",
      filter: false,
      section: "to",
      selectOption: true,
      multi: true,
    },
    {
      field: "ports_to",
      label: "Ports",
      control: "dynamic",
      api: "/api/ports",
      filter: false,
      section: "to",
      selectOption: true,
      multi: true,
    },
    {
      field: "expiration_date",
      label: "Expire Validity Date",
      control: "date",
      filter: false,
      range: false,
      section: "other",
    },
    {
      field: "customers",
      label: "Special Agreement",
      control: "dynamic",
      api: "/api/customers/names",
      filter: false,
      section: "other",
      multi: true,
    },
    {
      field: "comment",
      label: "Note",
      control: "textfield",
      multiline: true,
      section: "other",
      filter: false,
    },
    {
      field: "packages",
      label: "Macro Service",
      control: "dynamic",
      api: "/api/packages",
      filter: false,
      section: "other",
      multi: true,
    },
    {
      field: "service",
      label: "Service Master",
      mapper: "master",
      control: "dynamic",
      api: "/api/services?type=ACTIVE",
      create: false,
      view: false,
      multi: true,
      option: "description_it",
    },
    {
      field: "port",
      label: "Port",
      control: "dynamic",
      api: "/api/ports",
      create: false,
      view: false,
      multi: true,
    },
    {
      field: "commodity",
      label: "Commodity",
      control: "dynamic",
      api: "/api/commodities",
      create: false,
      view: false,
      multi: true,
      mapper: "commodity",
      option: "name_it",
    },
    {
      field: "customer",
      label: "Special Agreement",
      control: "dynamic",
      api: "/api/customers/names",
      create: false,
      view: false,
      multi: true,
    },
    {
      field: "carrier",
      label: "Carrier",
      control: "dynamic",
      api: "/api/suppliers/names",
      create: false,
      view: false,
      multi: true,
    },
    {
      field: "package",
      label: "Macro Service",
      control: "dynamic",
      api: "/api/packages",
      create: false,
      view: false,
      multi: true,
    },
    {
      field: "from_",
      label: "From",
      control: "textfield",
      create: false,
      view: false,
    },
    {
      field: "to_",
      label: "To",
      control: "textfield",
      create: false,
      view: false,
    },
  ],
};

export const PPL_ENTITY_CONFIG: SettingsEntityConfigByKey<"ppl"> = {
  key: "ppl",
  label: "PPL",
  item: "PPL",
  path: "ppl",
  endpoints: {
    list: "/api/prices/passive?show_all=true",
    getOne: (id) => `/api/prices/passive/${id}`,
    create: "/api/prices/passive",
    update: (id) => `/api/prices/passive/${id}`,
    delete: (id) => `/api/prices/passive/${id}`,
    restore: (id) => `/api/prices/passive/${id}/restore`,
  },
  columns: [],
  fields: [
    {
      field: "route",
      label: "Route",
      control: "autocomplete",
      options: ROUTES,
      required: true,
      section: "general",
      filter: false,
      view: false,
      update: true,
    },
    {
      field: "service__route",
      label: "Route",
      control: "autocomplete",
      options: ROUTES,
      disabled: true,
      section: "general",
      filter: true,
      view: false,
      update: false,
      create: false,
    },
    {
      field: "service_id",
      label: "Service Master",
      control: "dynamic",
      api: "/api/services?type=PASSIVE",
      required: true,
      mapper: "master",
      section: "general",
      filter: false,
      update: true,
      option: "description_it",
      dependency: "route",
      dependencyParam: "route__in",
      initialValueMapper: (row) =>
        row.service_id
          ? {
              id: row.service_id,
              label: row.description_it || row.description,
            }
          : null,
    },
    {
      field: "ports",
      label: "Port",
      control: "dynamic",
      api: "/api/ports",
      path: "parent.id",
      multi: true,
      filter: false,
      required: true,
      section: "general",
    },
    {
      field: "supplier",
      label: "Supplier",
      control: "dynamic",
      api: "/api/suppliers/names",
      path: "supplier.name",
      filter: false,
      required: true,
      section: "general",
    },
    {
      field: "commodities",
      label: "Commodities",
      control: "groupped",
      filter: false,
      multi: true,
      section: "general",
      mapper: "commodityWithGroup",
      required: true,
    },
    {
      field: "price_currency",
      label: "Currency",
      control: "autocomplete",
      options: CURRENCY,
      required: true,
      section: "general",
    },
    {
      field: "warehouses_from",
      label: "Warehouses",
      control: "dynamic",
      api: "/api/warehouses",
      filter: false,
      section: "from",
      selectOption: true,
      multi: true,
    },
    {
      field: "terminals_from",
      label: "Terminals",
      control: "dynamic",
      api: "/api/terminals",
      filter: false,
      section: "from",
      selectOption: true,
      multi: true,
    },
    {
      field: "cities_from",
      label: "Cities",
      control: "dynamic",
      api: "/api/cities",
      filter: false,
      section: "from",
      selectOption: true,
      multi: true,
    },
    {
      field: "ports_from",
      label: "Ports",
      control: "dynamic",
      api: "/api/ports",
      filter: false,
      section: "from",
      selectOption: true,
      multi: true,
    },
    {
      field: "warehouses_to",
      label: "Warehouses",
      control: "dynamic",
      api: "/api/warehouses",
      filter: false,
      section: "to",
      selectOption: true,
      multi: true,
    },
    {
      field: "terminals_to",
      label: "Terminals",
      control: "dynamic",
      api: "/api/terminals",
      filter: false,
      section: "to",
      selectOption: true,
      multi: true,
    },
    {
      field: "cities_to",
      label: "Cities",
      control: "dynamic",
      api: "/api/cities",
      filter: false,
      section: "to",
      selectOption: true,
      multi: true,
    },
    {
      field: "ports_to",
      label: "Ports",
      control: "dynamic",
      api: "/api/ports",
      filter: false,
      section: "to",
      selectOption: true,
      multi: true,
    },
    {
      field: "expiration_date",
      label: "Expire Validity Date",
      control: "date",
      filter: false,
      range: false,
      section: "other",
    },
    {
      field: "customers",
      label: "Special Agreement",
      control: "dynamic",
      api: "/api/customers/names",
      filter: false,
      section: "other",
      multi: true,
    },
    {
      field: "comment",
      label: "Note",
      control: "textfield",
      multiline: true,
      section: "other",
      filter: false,
    },
    {
      field: "service",
      label: "Service Master",
      mapper: "master",
      control: "dynamic",
      api: "/api/services?type=PASSIVE",
      create: false,
      view: false,
      multi: true,
      option: "description_it",
    },
    {
      field: "port",
      label: "Port",
      control: "dynamic",
      api: "/api/ports",
      create: false,
      view: false,
      multi: true,
    },
    {
      field: "commodity",
      label: "Commodity",
      control: "dynamic",
      api: "/api/commodities",
      create: false,
      view: false,
      multi: true,
      mapper: "commodity",
      option: "name_it",
    },
    {
      field: "customer",
      label: "Special Agreement",
      control: "dynamic",
      api: "/api/customers/names",
      create: false,
      view: false,
      multi: true,
    },
    {
      field: "supplier",
      label: "Supplier",
      control: "dynamic",
      api: "/api/suppliers/names",
      create: false,
      view: false,
      multi: true,
    },
    {
      field: "from_",
      label: "From",
      control: "textfield",
      create: false,
      view: false,
    },
    {
      field: "to_",
      label: "To",
      control: "textfield",
      create: false,
      view: false,
    },
  ],
};
